import { render, staticRenderFns } from "./PageDiarie.vue?vue&type=template&id=4bddebd7&scoped=true&"
import script from "./PageDiarie.vue?vue&type=script&lang=js&"
export * from "./PageDiarie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bddebd7",
  null
  
)

export default component.exports